window.getOffsetY = function (el) {
  var rect = el.getBoundingClientRect();
  return Math.round(rect.top + window.scrollY);
};